import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import config from "config";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppContainer from "./appcontainer";

const AppRouter = (props) => {
  return (
    <>
      <Router basename={`${config.publicPath}`}>
        <AppContainer {...props} />
      </Router>
      <ToastContainer />
    </>
  );
};

export default AppRouter;
